module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"extendedName":"TRiage Against Covid-19","startForm":"Nuovo questionario","userData":"Le tue risorse","seePrevForms":"Questionari compilati","seeMailAddresses":"Gestisci E-mail"}}')
  delete Component.options._Ctor
}
